/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    INVENTORY_PAGE_SPLIT_HOOK_STATE
 * Date:         2025-12-30
 * Modified By:  Cursor
 *
 * Description:
 * Extracted state management from InventoryPage.tsx.
 *
 * File Size Check:
 * - Current: ~80 lines
 * - Target: <100 lines
 * - Decision: Split completed
 */

import { useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { InventoryState } from "../types";
import { mockMeta } from "../utils/inventoryHelpers";
import { Inventory } from "../../../../interfaces/Inventory";

export const useInventoryState = () => {
  const location = useLocation();

  const getInitialSearchQuery = () => {
    const searchParams = new URLSearchParams(location.search);
    return searchParams.get("q") || "";
  };

  const initialQuery = getInitialSearchQuery();
  const [state, setState] = useState<InventoryState>({
    q: initialQuery,
    filterKeyword: "",
    partNumber: "",
    category: "",
    condition: "",
    country: "",
    manufacturer: "",
    minPrice: 0,
    maxPrice: 0,
    sort: "newest",
    page: 1,
    itemsPerPage: 10,
    items: [],
    allInventoryItems: [],
    total: 0,
    pages: 0,
    loading: false,
    error: null,
    meta: mockMeta,
    filtersCollapsed: true, // [2026-02-13] UX: Default filters to collapsed
  });

  const filteredInventoryItems = useMemo(() => {
    let filtered = state.allInventoryItems;

    if (state.filterKeyword && state.filterKeyword.trim()) {
      const keyword = state.filterKeyword.trim().toLowerCase();
      filtered = filtered.filter((item: Inventory) => {
        return (
          (item.title && item.title.toLowerCase().includes(keyword)) ||
          (item.manufacturer && item.manufacturer.toLowerCase().includes(keyword)) ||
          (item.model && item.model.toLowerCase().includes(keyword)) ||
          (item.partNumber && item.partNumber.toLowerCase().includes(keyword)) ||
          (item.description && item.description.toLowerCase().includes(keyword))
        );
      });
    }

    if (state.partNumber) {
      filtered = filtered.filter((item: Inventory) => {
        return item.partNumber && item.partNumber.trim() === state.partNumber;
      });
    }

    return filtered;
  }, [state.allInventoryItems, state.filterKeyword, state.partNumber]);

  return { state, setState, filteredInventoryItems };
};
